import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import { Loader } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import APIEndpoints from '../../../api/APIEndpoints';
import { HttpSuccessCodes } from '../../../errorhandling/HttpErrorCodes';
import GetAdminConfiguration from '../../../api/GetAdminConfig';
import { axiosInstance } from '../../../../api/axios';
import { ClaimDetailsSVG } from '../../../img/GlobalSVG';
import MemberAndDependentSkeleton from './MemberAndDependentSkeleton';

const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

const MemberAndDependent = (props) => {
  const { onChange, hasEditPermission } = props;
  const { values, errors, errorValidation } = props;
  const { memberAndDependentEditable, loadDefaultPermissionHandler } = props;
  const [loadingClientSettings, setLoadingClientSettings] = useState(false);

  const { employer } = useSelector((state) => state.breadCrumb);

  useEffect(() => {
    const getClientConfiguration = async () => {
      setLoadingClientSettings(true);
      loadDefaultPermissionHandler(true);
      let ClientConfigurationtData = null;
      let event;

      if (employer.key !== 'all') {
        try {
          const ClientConfigurationResponse = await axiosInstance.get(
            cacheBuster(
              APIEndpoints.getClientConfigResources() +
                'clientoid/' +
                employer.key,
            ),
          );
          ClientConfigurationtData = ClientConfigurationResponse.data;

          if (
            ClientConfigurationResponse.status ===
            HttpSuccessCodes.HTTP_SUCCESS_CODE_200
          ) {
            event = {
              target: {
                name: 'allowMember',
                value:
                  ClientConfigurationtData.Response.AllowMembersToRegister ===
                  'true',
              },
            };
            onChange(event);

            event = {
              target: {
                name: 'allowDependent',
                value:
                  ClientConfigurationtData.Response
                    .AllowDependentsToRegister === 'true',
              },
            };
            onChange(event);

            event = {
              target: {
                name: 'minAge',
                value:
                  ClientConfigurationtData.Response
                    .DependentRegistrationAgeLimit,
              },
            };
            onChange(event);

            event = {
              target: {
                name: 'clientConfiguration',
                value: ClientConfigurationtData.Response.OID,
              },
            };
            onChange(event);
          }
          setLoadingClientSettings(false);
          loadDefaultPermissionHandler(false);
        } catch (error) {
          //let errorMessage = '';
          //let requestAborted = '';
          //if ( error ) {
          //errorMessage = error.toString();
          //requestAborted = errorMessage.match( /aborted/i );
          //}
          event = { target: { name: 'allowMember', value: false } };
          onChange(event);

          event = { target: { name: 'allowDependent', value: false } };
          onChange(event);

          event = { target: { name: 'minAge', value: 1 } };
          onChange(event);

          event = { target: { name: 'clientConfiguration', value: null } };
          onChange(event);
          setLoadingClientSettings(false);
          loadDefaultPermissionHandler(false);
        }
      } else {
        event = {
          target: {
            name: 'allowMember',
            value:
              GetAdminConfiguration.AllowMembersToRegister === 'true'
                ? true
                : false,
          },
        };
        onChange(event);

        event = {
          target: {
            name: 'allowDependent',
            value:
              GetAdminConfiguration.AllowDependentsToRegister === 'true'
                ? true
                : false,
          },
        };
        onChange(event);

        event = {
          target: {
            name: 'minAge',
            value: GetAdminConfiguration.DependentRegistrationAgeLimit,
          },
        };
        onChange(event);

        event = { target: { name: 'clientConfiguration', value: null } };
        onChange(event);
        setLoadingClientSettings(false);
        loadDefaultPermissionHandler(false);
      }
      setLoadingClientSettings(false);
      loadDefaultPermissionHandler(false);
      props.rerenderPage();
    };
    document.addEventListener('employer-update', getClientConfiguration);
    getClientConfiguration();

    return () => {
      window.removeEventListener('employer-update', getClientConfiguration);
    };
  }, [employer.key]);

  return (
    <Row className="Payment-details member-and-dependent">
      <Col className="pl-0">
        <h3
          className={errorValidation.dependentMinimumAge ? 'errorValidate' : ''}
        >
          Member and Dependent
        </h3>
        <p className="mb-2">
          Identify the user (whether he or she is a Member <br />
          or Dependent) and define the minimum age for the Dependent to
          register.
        </p>
        {errorValidation.dependentMinimumAge && (
          <div className="d-flex align-items-center">
            <ClaimDetailsSVG.ExclamationSVG />
            <p className="errorMessage ml-2">
              {' '}
              Define minimum age for Dependents to register.
            </p>
          </div>
        )}
      </Col>
      {loadingClientSettings && <MemberAndDependentSkeleton />}
      {!loadingClientSettings && (
        <Col className="setup-form">
          <Form.Group id="formGridallowMember">
            <Form.Label for="allowMember1">Allow Member to register</Form.Label>
            <Form.Check
              type="checkbox"
              checked={values.allowMember}
              id="allowMember"
              onChange={onChange}
              label="User would be allowed to register to the portal, if he or she is a Member"
              name="allowMember"
              disabled={!memberAndDependentEditable || !hasEditPermission}
              isDisabled={!hasEditPermission}
              className={!hasEditPermission && 'disabled-checkbox'}
            />
          </Form.Group>
          <Form.Group id="formGridallowDependent">
            <Form.Label for="allowDependent1">
              Allow Dependent to register
            </Form.Label>
            <Form.Check
              type="checkbox"
              checked={values.allowDependent}
              onChange={onChange}
              id="allowDependent"
              label="User would be allowed to register to the portal, if he or she is a Dependent with age limitation"
              name="allowDependent"
              disabled={!memberAndDependentEditable || !hasEditPermission}
              isDisabled={!hasEditPermission}
              className={!hasEditPermission && 'disabled-checkbox'}
            />
          </Form.Group>
          {values.allowDependent && (
            <Form.Group controlId="formBasicminAge">
              <Form.Label className="reg-lable" for="minAge">
                Minimum age for the dependent to register
              </Form.Label>
              <Form.Control
                value={values.minAge}
                onChange={onChange}
                id="minAge"
                name="minAge"
                isInvalid={errors.minAge}
                disabled={!memberAndDependentEditable || !hasEditPermission}
                className={
                  errorValidation.dependentMinimumAge
                    ? 'errorValidateInput'
                    : ''
                }
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                <span role="alert">{errors.minAge}</span>
              </Form.Control.Feedback>
            </Form.Group>
          )}
        </Col>
      )}
    </Row>
  );
};

export default MemberAndDependent;
